'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeUserReference(id, fullName) {
  this.Lapp_api_GeneralPracticeUserReference__f_id = null;
  this.Lapp_api_GeneralPracticeUserReference__f_fullName = null;
  this.Lapp_api_GeneralPracticeUserReference__f_id = id;
  this.Lapp_api_GeneralPracticeUserReference__f_fullName = fullName;
}
export { $c_Lapp_api_GeneralPracticeUserReference as $c_Lapp_api_GeneralPracticeUserReference };
$c_Lapp_api_GeneralPracticeUserReference.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeUserReference.prototype.constructor = $c_Lapp_api_GeneralPracticeUserReference;
/** @constructor */
function $h_Lapp_api_GeneralPracticeUserReference() {
}
export { $h_Lapp_api_GeneralPracticeUserReference as $h_Lapp_api_GeneralPracticeUserReference };
$h_Lapp_api_GeneralPracticeUserReference.prototype = $c_Lapp_api_GeneralPracticeUserReference.prototype;
$c_Lapp_api_GeneralPracticeUserReference.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 596453805, true);
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_GeneralPracticeUserReference)) {
    var x = this.Lapp_api_GeneralPracticeUserReference__f_id;
    var x$2 = x$0.Lapp_api_GeneralPracticeUserReference__f_id;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return (this.Lapp_api_GeneralPracticeUserReference__f_fullName === x$0.Lapp_api_GeneralPracticeUserReference__f_fullName);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.productPrefix__T = (function() {
  return "GeneralPracticeUserReference";
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_GeneralPracticeUserReference__f_id;
  }
  if ((n === 1)) {
    return this.Lapp_api_GeneralPracticeUserReference__f_fullName;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeUserReference.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "fullName";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_GeneralPracticeUserReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_GeneralPracticeUserReference)));
}
export { $isArrayOf_Lapp_api_GeneralPracticeUserReference as $isArrayOf_Lapp_api_GeneralPracticeUserReference };
var $d_Lapp_api_GeneralPracticeUserReference = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeUserReference, "app.api.GeneralPracticeUserReference", ({
  Lapp_api_GeneralPracticeUserReference: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_GeneralPracticeUserReference as $d_Lapp_api_GeneralPracticeUserReference };
//# sourceMappingURL=app.api.-General-Practice-User-Reference.js.map
